<template>
  <KikParagraph :content="mgnlProps.content" />
</template>

<script lang="ts" setup>
import { ParagraphBuilder, WrapperProps } from './Paragraph.model';
import KikParagraph from '~/components/Shared/Forms/Paragraph/Paragraph.vue';

const props = defineProps(WrapperProps);
const mgnlProps = computed(() => ParagraphBuilder.build(props));
</script>
